module.exports = __webpack_public_path__ + "img/dark_box3_item_bg2.69f33e88.png";